import React from 'react';
import { makeStyles, Backdrop, CircularProgress } from '@mui/material';

// const useStyles = makeStyles((theme) => ({
//   backdrop: {
//     zIndex: theme.zIndex.drawer + 1,
//     color: '#fff',
//   },
// }));

const LoadingSpinner: React.FC = () => {
  // const classes = useStyles();

  return (
    <Backdrop sx={{ color: '#fff' }} open>
      <CircularProgress color='inherit' />
    </Backdrop>
  );
};

export default LoadingSpinner;
